module.exports = __webpack_public_path__ + "img/T5-D-rc_1.002c43de.png";